<div class="highlight-cards-wrapper">
    <mat-card class="highlight-card mat-elevation-z4" *ngFor="let card of cards" gtagEvent trackOn="click"
              action="pretty-card-click" category="cards">
        <mat-card-header>
            <mat-card-title>{{card.name}}</mat-card-title>
            <mat-card-subtitle>{{card.type}}</mat-card-subtitle>
        </mat-card-header>
        <div [style.text-align]="'center'" [style.width]="'100%'">
            <app-card-image [width]="250" [card]="card" [clickable]="false" [draggable]="false"></app-card-image>
        </div>
    </mat-card>
</div>